import React from "react";
import dayjs from "../../../../../utils/dayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle, faClock, faExclamationCircle, faFileAlt } from "@fortawesome/free-solid-svg-icons";

const TaskCardReported = ({ task, currentUserId, onSelect }) => {
  const taskItems = Array.isArray(task.task_list) ? task.task_list.slice(0, 3) : [];
  const taskCount = Array.isArray(task.task_list) ? task.task_list.length : 0;

  // 🧮 Đếm số việc được giao
  const assignedCount = Array.isArray(task.task_list)
    ? task.task_list.filter((t) => t.task_type === "assigned").length
    : 0;

  // 🗓 Ngày thực hiện
  const today = dayjs().tz().startOf("day");
  const workDate = task.work_day ? dayjs(task.work_day).tz().startOf("day") : dayjs.invalid();
  const diffDays = workDate.diff(today, "day");
  const formattedDate = workDate.isValid() ? workDate.format("DD-MMM-YYYY") : "-";
  const label = `Đã báo cáo ${taskCount} việc ngày ${formattedDate}`;

  // 🕓 Tag thời gian còn lại
  let tagText = "";
  let tagColor = "";
  if (diffDays > 0) {
    tagText = `Còn ${diffDays} ngày`;
    tagColor = "bg-green-100 text-green-700 border border-green-300";
  } else if (diffDays === 0) {
    tagText = "Đến hạn hôm nay";
    tagColor = "bg-yellow-100 text-yellow-700 border border-yellow-300";
  } else {
    tagText = `Quá hạn ${Math.abs(diffDays)} ngày`;
    tagColor = "bg-red-100 text-red-700 border border-red-300";
  }

  // 🧑 Avatar
  const avatar = task.avatar_url ? (
    <img src={task.avatar_url} alt="avatar" className="w-8 h-8 rounded-full mr-2 object-cover" />
  ) : (
    <div className="w-8 h-8 rounded-full mr-2 bg-gray-200 flex items-center justify-center">
      <FontAwesomeIcon icon={faUserCircle} className="text-gray-400 text-xl" />
    </div>
  );

  // 🎨 Nền tổng thể
  let cardBg = "bg-white";
  if (diffDays < 0) cardBg = "bg-red-50";
  else if (diffDays === 0) cardBg = "bg-yellow-50";

  // return (
  //   <div
  //     onClick={() =>
  //       onSelect?.({
  //         employee_id: task.employee_id,
  //         employee_name: task.employee_name,
  //         work_day: dayjs(task.work_day).format("YYYY-MM-DD"),
  //       })
  //     }
  //     className={`relative w-full border rounded-xl sm:rounded-2xl 
  //       p-3 sm:p-4 shadow-sm hover:shadow-lg 
  //       hover:border-blue-400 transition-all duration-200 cursor-pointer 
  //       flex flex-col justify-between min-h-[120px] sm:min-h-[180px] ${cardBg}`}
  //   >

  //     {/* 🔖 Nhóm tag góc phải: Trạng thái + số việc được giao */}
  //     <div className="absolute top-0 right-0 flex flex-col items-end">

  //       {/* 🔥 Ribbon trạng thái */}
  //       {task.status === "reported" && (
  //         <div
  //           className={`
  //             px-3 py-[5px] text-[10px] font-semibold tracking-wide shadow-sm
  //             rounded-bl-lg rounded-tr-lg text-white
  //             ${
  //               task.can_approve
  //                 ? "bg-gradient-to-r from-red-400 to-red-500"    // CẦN BẠN DUYỆT
  //                 : "bg-blue-500"                                 // ĐÃ BÁO CÁO
  //             }
  //           `}
  //           title={task.can_approve ? "Bạn là người duyệt hiện tại" : undefined}
  //         >
  //           {task.can_approve ? "CẦN DUYỆT" : "ĐÃ BÁO CÁO"}
  //         </div>
  //       )}

  //       {/* 🔥 Tag số việc được giao */}
  //       {assignedCount > 0 && (
  //         <span
  //           className="
  //             mt-[4px] mr-[2px]
  //             px-2 py-[2px] text-[10.5px] font-semibold rounded-md
  //             bg-red-100 text-red-700 shadow-sm leading-none
  //           "
  //         >
  //           +{assignedCount} việc
  //         </span>
  //       )}
  //     </div>

  //     {/* 🕒 Tag đếm ngược */}
  //     <div
  //       className={`absolute top-2 left-2 text-[11px] px-2 py-[3px] rounded-full font-medium flex items-center gap-1 ${tagColor}`}
  //     >
  //       <FontAwesomeIcon icon={faClock} className="text-[10px]" />
  //       {tagText}
  //     </div>

  //     {/* 🧑 Header */}
  //     <div className="flex items-center mb-2 mt-6">
  //       {avatar}
  //       <div className="flex-1 min-w-0">
  //         <div className="font-semibold text-gray-800 text-sm truncate">{task.employee_name}</div>
  //         <div className="text-xs text-gray-500 truncate">
  //           {task.department_name || task.branch_name || "—"}
  //         </div>

  //         {/* TAGS */}
  //         {task.tags && task.tags.length > 0 && (
  //           <div className="flex flex-wrap gap-1 mt-2">
  //             {task.tags.map((tag) => (
  //               <span
  //                 key={tag.tag_id}
  //                 className="text-[9px] px-2 py-[2px] rounded-full border"
  //                 style={{
  //                   backgroundColor: "#F3F4F6", // nền xám nhẹ
  //                   color: "#4B5563",           // chữ xám đậm vừa
  //                   borderColor: "#D1D5DB",     // border xám nhạt
  //                 }}
  //               >
  //                 {tag.tag_name}
  //               </span>
  //             ))}
  //           </div>
  //         )}
  //       </div>
  //     </div>

  //     {/* 📋 Danh sách công việc */}
  //     <div className="text-sm text-gray-700 flex-1 space-y-1 pl-1">
  //       {taskItems.length > 0 ? (
  //         taskItems.map((work, i) => (
  //           <div key={i} className="flex" title={work.taskname}>
  //             <span className="mr-1 text-gray-500">{i + 1}.</span>
  //             <span className="flex-1 overflow-hidden text-ellipsis whitespace-nowrap">
  //               {work.taskname}
  //             </span>
  //           </div>
  //         ))
  //       ) : (
  //         <div className="italic text-gray-400">Không có công việc</div>
  //       )}
  //     </div>

  //     {/* 📅 Ghi chú + tag “+x việc được giao” */}
  //     {/* <div className="mt-2 ml-3 text-xs italic text-gray-400 flex justify-between items-center">
  //       <span>{label}</span>
  //       {assignedCount > 0 && (
  //         <span className="text-[11px] px-2 py-[2px] rounded-full font-medium bg-red-100 text-red-700 border border-red-300 shadow-sm">
  //           +{assignedCount} việc
  //         </span>
  //       )}
  //     </div> */}
  //   </div>
  // );

  return (
    <div
      onClick={() =>
        onSelect?.({
          employee_id: task.employee_id,
          employee_name: task.employee_name,
          work_day: dayjs(task.work_day).format("YYYY-MM-DD"),
        })
      }
      className={`group relative w-full border rounded-2xl p-4 shadow-sm 
        hover:shadow-xl hover:border-blue-400 hover:-translate-y-1
        active:scale-[0.98] transition-all duration-300 cursor-pointer 
        flex flex-col min-h-[180px] ${cardBg} overflow-hidden`}
    >
      {/* 🔖 Hệ thống Ribbon 3D & Badge */}
      <div className="absolute top-0 right-0 z-10 flex flex-col items-end">
        {/* Ribbon Trạng thái */}
        {task.status === "reported" && (
          <div className="relative flex flex-col items-end">
            <div
              className={`
                relative px-3 py-1.5 text-[10px] font-black tracking-widest uppercase
                rounded-bl-xl shadow-sm flex items-center gap-1.5 transition-all duration-300 text-white
                ${task.can_approve 
                  ? "bg-gradient-to-br from-red-500 to-rose-600 animate-pulse" 
                  : "bg-gradient-to-br from-blue-500 to-indigo-600"
                }
              `}
            >
              <div className="absolute inset-0 bg-black/5 rounded-bl-xl pointer-events-none"></div>
              <FontAwesomeIcon 
                icon={task.can_approve ? faExclamationCircle : faFileAlt} 
                className="text-[11px]" 
              />
              <span className="relative">
                {task.can_approve ? "Cần duyệt" : "Đã báo cáo"}
              </span>
  
              {/* Indicator cho trường hợp Cần duyệt */}
              {task.can_approve && (
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
                </span>
              )}
            </div>
            
            {/* Mép gấp 3D */}
            <div className={`w-0 h-0 border-l-[6px] border-l-transparent border-t-[6px] 
              ${task.can_approve ? "border-t-red-700" : "border-t-indigo-700"}`}
            ></div>
          </div>
        )}
  
        {/* Tag số việc được giao (bám sát dưới Ribbon) */}
        {assignedCount > 0 && (
          <div className="mt-1 mr-1 flex items-center gap-1 bg-red-50 text-red-600 text-[10px] font-bold px-2 py-0.5 rounded-md border border-red-100 shadow-sm transition-transform group-hover:scale-105">
            <span className="w-1 h-1 rounded-full bg-red-500 animate-pulse"></span>
            +{assignedCount} việc phát sinh
          </div>
        )}
      </div>
  
      {/* 🕒 Tag đếm ngược (Top Left) */}
      <div className={`absolute top-3 left-3 flex items-center gap-1.5 px-2 py-0.5 rounded-lg font-bold text-[10px] uppercase tracking-wider ${tagColor} bg-opacity-10 border border-current/20`}>
        <FontAwesomeIcon icon={faClock} className="text-[9px]" />
        {tagText}
      </div>
  
      {/* 🧑 Header: Avatar & Info */}
      <div className="flex items-center gap-3 mb-4 mt-7">
        <div className="ring-2 ring-white shadow-sm rounded-full overflow-hidden shrink-0">
          {avatar}
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-bold text-gray-800 text-sm truncate group-hover:text-red-600 transition-colors">
            {task.employee_name}
          </div>
          <div className="text-[11px] text-gray-500 font-medium truncate uppercase tracking-tighter opacity-80">
            {task.department_name || task.branch_name || "—"}
          </div>
        </div>
      </div>
  
      {/* 📋 Danh sách công việc */}
      <div className="flex-1 space-y-1.5 pl-1 mb-3">
        {taskItems.length > 0 ? (
          taskItems.slice(0, 3).map((work, i) => (
            <div key={i} className="flex items-start gap-2 text-[13px] text-gray-600 group/item" title={work.taskname}>
              <div className="mt-1.5 w-1 h-1 rounded-full bg-gray-400 group-hover/item:scale-150 transition-transform"></div>
              <span className="flex-1 overflow-hidden text-ellipsis whitespace-nowrap italic font-medium">
                {work.taskname}
              </span>
            </div>
          ))
        ) : (
          <div className="italic text-gray-400 text-xs py-1">Chưa có nội dung báo cáo</div>
        )}
        {taskItems.length > 3 && (
          <div className="text-[10px] text-gray-600 font-bold ml-3 italic">
            + {taskItems.length - 3} đầu việc khác...
          </div>
        )}
      </div>
  
      {/* 📅 Footer: Tags & Label */}
      <div className="mt-auto pt-3 border-t border-gray-50 flex flex-wrap items-center justify-between gap-2">
        <div className="flex flex-wrap gap-1">
          {task.tags?.slice(0, 2).map((tag) => (
            <span key={tag.tag_id} className="text-[9px] font-bold px-1.5 py-0.5 rounded bg-gray-50 text-gray-400 border border-gray-200">
              #{tag.tag_name}
            </span>
          ))}
        </div>
        <div className="text-[10px] italic font-medium text-gray-400 lowercase">{label}</div>
      </div>
    </div>
  );

};

export default TaskCardReported;
